/* Mapping credit situation icon for Installments (MDW) */
export const iconMapper = situation => {
    const situationIcon = {
        L: 'check-circle',
        9: 'error',
        F: 'error',
        N: 'clock',
        1: 'warning',
        2: 'warning',
        3: 'warning',
        4: 'warning',
        5: 'warning',
        V: 'warning',
        U: 'check-folder',
        E: 'check-folder',
        R: 'check-folder',
        8: 'check-folder',
        X: 'check-folder'
    }

    return situationIcon[situation]
}

/* Mapping credit situation color icon for Installments (MDW) */
export const iconColorMapper = situation => {
    const situationIconColor = {
        L: 'positive',
        9: 'negative',
        F: 'negative',
        N: 'warning',
        1: 'negative',
        2: 'negative',
        3: 'negative',
        4: 'negative',
        5: 'negative',
        V: 'negative',
        U: 'secondary',
        E: 'secondary',
        R: 'secondary',
        8: 'secondary',
        X: 'secondary'
    }

    return situationIconColor[situation]
}

/* Mapping credit icon status for Modal Installments (to have the icon with just the lines instead of filled) */
export const iconModalMapper = iconName => {
    const icon = {
        'check-circle': 'check-circle',
        error: 'error',
        warning: 'warning',
        clock: 'clock',
        'check-folder': 'check-folder'
    }

    return icon[iconName]
}

/* Mapping header color for Modal Installments */
export const colorStatusMapper = status => {
    const colorStatus = {
        default: 'var(--secondary)',
        positive: 'var(--positive)',
        warning: 'var(--warning)',
        negative: 'var(--negative)'
    }

    return colorStatus[status]
}

/* Mapping credit situation icon for Modal Installments (MDW) */
export const iconMapperModal = situation => {
    const situationIcon = {
        L: 'check-circle',
        9: 'error',
        F: 'error',
        N: 'clock',
        1: 'warning',
        2: 'warning',
        3: 'warning',
        4: 'warning',
        5: 'warning',
        V: 'warning',
        U: 'check-folder',
        E: 'check-folder',
        R: 'check-folder',
        8: 'check-folder',
        X: 'check-folder'
    }

    return situationIcon[situation]
}

/* Mapping credit situation color for Modal Installments (MDW) */
export const colorStatusMapperModal = situation => {
    const situationColor = {
        L: 'var(--positive)',
        9: 'var(--negative)',
        F: 'var(--negative)',
        N: 'var(--warning)',
        1: 'var(--negative)',
        2: 'var(--negative)',
        3: 'var(--negative)',
        4: 'var(--negative)',
        5: 'var(--negative)',
        V: 'var(--negative)',
        U: 'var(--secondary)',
        E: 'var(--secondary)',
        R: 'var(--secondary)',
        8: 'var(--secondary)',
        X: 'var(--secondary)'
    }

    return situationColor[situation]
}
